// extracted by mini-css-extract-plugin
export default {"container":"UnitSelectionPage__container___hytWz"};